
// ══════════════════════════════════════════════════════════════════
// AR — reemplaza tu export const booking en el archivo de árabe
// ══════════════════════════════════════════════════════════════════
export const booking = {
  createBooking: "إنشاء حجز",
  detailsTitle: "تفاصيل الحجز",
  createdOn: "أُنشئ في",
  statusBooked: "محجوز",
  processing: "جارٍ المعالجة...",
  reject: "رفض",
  cancelled: "تم إلغاء الحجز",
  guests: "الضيوف",
  nights: "الليالي",

  responsibleTitle: "المسؤول عن الحجز",
  name: "الاسم",
  email: "البريد الإلكتروني",
  emailNotProvided: "لم يُقدَّم بريد إلكتروني",
  phone: "الهاتف",
  phoneNotProvided: "لم يُقدَّم رقم هاتف",
  replyWhatsapp: "الرد عبر WhatsApp",
  notes: "ملاحظة",
  notesEmpty: "لا توجد ملاحظة",
  notesPlaceholder: "ملاحظات داخلية للحجز (مثل الوصول المتأخر، سرير أطفال، حساسية…)",
  notesEdit: "تعديل الملاحظة",
  notesSave: "حفظ",
  notesCancel: "إلغاء",
  notesSaved: "تم تحديث الملاحظة",
  notesSaveError: "تعذّر حفظ الملاحظة",

  amountTitle: "مبلغ الحجز",

  // Menu buttons & states
  validatingLink: "جارٍ التحقق من الرابط...",
  sendPaymentLink: "إرسال رابط الدفع",
  copyPaymentLink: "نسخ رابط الدفع",
  sendingPaymentLink: "جارٍ إرسال رابط الدفع…",
  whatsappSent: "تم إرسال رابط الدفع عبر WhatsApp.",
  whatsappSentFallback: "فشل إرسال القالب. تم فتح WhatsApp يدويًا.",
  freeReservationInfo: "حجز مجاني - لا يتطلب دفعًا",
  stripeNotConfigured: "Stripe غير مُعَدّ",
  changePaymentStatus: "تغيير حالة الدفع",

  // Amount status
  amountStatus: "حالة المبلغ",
  paymentPending: "بانتظار الدفع",
  paid: "مدفوع",
  rejected: "مرفوض",
  refunded: "مُسترَد",
  partial: "دفع جزئي",

  // Totals
  subtotal: "المجموع الفرعي:",
  totalDiscounts: "إجمالي الخصومات:",
  totalTaxes: "إجمالي الضرائب:",
  total: "الإجمالي:",

  // Payment status modal
  changePaymentStatusHeader: "تغيير حالة الدفع",
  paymentStatusLabel: "حالة الدفع",
  select: "اختر",
  pending: "معلّق",
  paidShort: "مدفوع",
  close: "إغلاق",
  saveChanges: "حفظ التغييرات",

  // Toastr / Messages
  paymentUrlSuccess: "تم إنشاء رابط الدفع بنجاح",
  paymentUrlError: "خطأ في إنشاء رابط الدفع",

  linkGenerated: "تم إنشاء رابط الدفع بنجاح",
  linkRegenerated: "تم تحديث رابط الدفع بسبب تغيّر الأسعار",
  linkPriceZero: "لا يمكن إنشاء رابط دفع للحجوزات المجانية ($0)",
  linkNoStripe: "لم يقم المستخدم بإعداد Stripe لاستلام المدفوعات",
  linkNoProvider: "لم يتم إعداد أي مزوّد دفع (Stripe أو Wompi)",  // ✅ NUEVA
  linkValidationFailed: "لا يمكن إنشاء رابط الدفع. توجد بيانات مطلوبة ناقصة.",
  linkValidateError: "خطأ في التحقق من رابط الدفع",
  linkValid: "رابط الدفع صالح",

  copySuccess: "تم نسخ الرابط بنجاح",
  copied: "تم النسخ!",
  copyError: "حدث خطأ أثناء نسخ الرابط",
  error: "خطأ",
  statusUpdatedSuccess: "تم تحديث الحالة بنجاح",
  statusUpdatedError: "خطأ في تحديث حالة الدفع",  // ✅ NUEVA

  // WhatsApp
  whatsappPayMessage: "مرحبًا {name}! إليك رابط دفع حجزك: {url}",

  checkinsOf: "عمليات تسجيل الوصول في هذا الحجز ({done} من {total})",
  completed: "مكتمل",
  pendings: "معلّق",
  date: "التاريخ",
  noCheckinsYet: "لم يُكمل ضيوف هذا الحجز تسجيل الوصول بعد",

  alojamiento: "مكان الإقامة",
};

